import { DialogService } from 'primeng/dynamicdialog';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { LoaderInterceptor } from './interceptors/loader.interceptor';
import { ErrorInterceptor } from './interceptors/error-interceptor';
import { ConfirmationService, MessageService } from 'primeng/api/';

import {
  ApiService,
  TokenService,
  ToastService,
  EncryptionService,
  CommonService,
  FileService,
  AuthService,
  UserService,
  RestaurantService,
  OutletService,
  ClientService,
  RewardService,
  CouponService,
  EventService,
  TableService,
  OrderService,
  MenuService,
  AddressService,
  PaymentService,
  NotificationService,
  GiftCardService
} from './services';

@NgModule({
  imports: [CommonModule],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    ApiService,
    TokenService,
    ToastService,
    EncryptionService,
    CommonService,
    DialogService,
    ConfirmationService,
    MessageService,
    AuthService,
    FileService,
    UserService,
    RestaurantService,
    OutletService,
    ClientService,
    RewardService,
    CouponService,
    EventService,
    TableService,
    OrderService,
    MenuService,
    AddressService,
    PaymentService,
    NotificationService,
    GiftCardService
  ],
})
export class CoreModule {}
